<template>
    <div id="app">
        <div class="header">
            <div class="backroutes">
                <img src="./assets/images/go-back.png" @click="backRoute"/>
            </div>
            <!--      <div class="drop-down" @click="showNav" v-show="isShowNav">-->
            <!--        <img src="./assets/images/dropdown.png" alt />-->
            <!--      </div>-->
            <!--      <div class="backroute" @click="backRoute" v-show="!isHome">-->
            <!--        <img src="./assets/images/backroute.png" alt />-->
            <!--      </div>-->
            <div class="name" >
                <img v-if="logo" :src="logo"  :style="['starworld-f08eb42647e2aa91a5c729e547ba49b3','starworld-2af8982d2789a9b475753749b9ccf6b0'].includes(mark)?{height:'38px'}:( ['starworld-f9a290e3af46f3e1e68ec294d8335248','starworld-3332f098f975c5706fcece81fdfcfcaf'].includes(mark)?{height:'1.5rem',width:'auto'}:{})"/>
                <!--                <img src="./assets/images/starlogoindex.png"/>-->
                <!--        <div class="title-name">客服中心</div>-->
            </div>
            <Login class="ear-icon"></Login>
        </div>
        <game-nav v-model="isShowHomeNav" v-if="isShowHomeNav"></game-nav>
        <hot-line v-model="isShowLine" v-if="isShowLine"></hot-line>
        <router-view/>
    </div>
</template>
<script>
import {mapState} from 'vuex';
import gameNav from '@/components/gameNav';
import hotLine from '@/components/hotLine';
import Login from './views/login';
import starlogo from './assets/images/starlogoindex.png';
import zhanhuoLogo from './assets/images/zhanhuo-logo.png';
import mnzlLogo from './assets/images/mnzl-logo.png';
import tnmnzlLogo from './assets/images/tmmnzl-logo.png';
import dsjyLogo from './assets/images/dsjy-logo.png';
import bbtsaxcLogo from './assets/images/bbtsaxc-logo.png';
import skdzzLogo from './assets/images/skdzz-logo.png';

export default {
    name: "App",
    components: {
        gameNav,
        hotLine,
        Login
    },
    data() {
        return {
            isShowHomeNav: false,
            isShowLine: false,
            // logo: null,
            // home: this.$route.path === '/' ? true : false,
        }
    },
    created() {
        console.log('cookie:',document?.cookie);
    },
    computed: {
        ...mapState(['isShowNav', 'isHome']),
        mark: function () {
            if (this.$route.query.mark) {
                return this.$route.query.mark;
            }
            return null;
        },
        logo: function () {
            if (this.$route.query.mark) {
                switch (this.$route.query.mark) {
                    case 'starworld-70b82b05626acebf7608c85834ad654a':
                        return zhanhuoLogo;
                    case 'starworld-4d869fd5b900b6fc1cb0c5bc8f6873a4':
                        return mnzlLogo;
                    case 'starworld-f08eb42647e2aa91a5c729e547ba49b3':
                        return dsjyLogo;
                    case 'starworld-2af8982d2789a9b475753749b9ccf6b0':
                        return tnmnzlLogo;
                    case 'starworld-f9a290e3af46f3e1e68ec294d8335248':
                        return bbtsaxcLogo;
                    case 'starworld-3332f098f975c5706fcece81fdfcfcaf':
                        return skdzzLogo;
                    default:
                        return starlogo;
                }
            }
            return null;
        }
    },
    methods: {
        showNav() {
            this.isShowHomeNav = !this.isShowHomeNav;
        },
        showLine() {
            this.isShowLine = !this.isShowLine;
        },
        backRoute() {
            this.$router.go(-1);
        }
    }
};
</script>

<style>
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    color: #333;
}
</style>
<style lang="scss" scoped>
#app {
    .header {
        display: flex;
        align-items: center;
        height: 120px;
        /*background: linear-gradient(#e1303a, #f04133);*/
        background: white;
        // justify-content: space-between;
        padding: 0 28px;
        position: relative;

        .drop-down {
            width: 40px;
            height: 40px;
            margin-right: 32px;
        }

        .backroutes {
            width: 40px;
            height: 40px;

            img {
                height: 50px;
            }
        }

        .name {
            position: absolute;
            left: 50%;
            transform: translate(-50%);

            img {
                width: 172px;
                height: 48px;
            }

            .title-name {
                font-size: 30px;
                font-weight: 600;
                color: rgb(216, 82, 67);
            }
        }

        .ear-icon {
            // width: 66px;
            // height: 44px;
            font-weight: bold;
            color: white;
            font-size: 32px;
            margin-left: auto;
        }

    }
}
</style>